"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.default = (function () {
    // creates handy classes that are good to use
    var noSelect = {
        userSelect: "none",
        msUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none"
    };
    var pointer = lodash_1.assign({}, noSelect, { cursor: "pointer !important" });
    return {
        noSelect: noSelect,
        pointer: pointer,
        block: { display: "block !important" },
        inlineBlock: { display: "inline-block !important" },
        invisible: { visibility: "hidden", opacity: 0 },
        noDisplay: { display: "none", opacity: 0 },
        separatorX: {
            height: "1px",
            width: "100%",
            flex: "0 0 1px",
            background: "$color-text-hint"
        },
        separatorY: {
            width: "1px",
            flex: "0 0 1px",
            alignSelf: "stretch",
            background: "$color-text-hint"
        },
        overflowHidden: { overflow: "hidden" },
        overflowAuto: { overflow: "auto" }
    };
});
//# sourceMappingURL=Handy.js.map